import styled from 'styled-components';

export const PageWrapper = styled.div`
  padding-bottom: 60px;
`;

/* ── HERO ── */
export const Hero = styled.section`
  padding: 40px 32px 36px;
  background: linear-gradient(160deg, #12101a 0%, #0d0d14 60%, #0B090B 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -60px; left: 50%;
    transform: translateX(-50%);
    width: 500px; height: 300px;
    background: radial-gradient(ellipse, rgba(147,51,234,0.12) 0%, transparent 70%);
    pointer-events: none;
  }

  .hero-label {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px;
    border-radius: 20px;
    background: rgba(147,51,234,0.1);
    border: 1px solid rgba(147,51,234,0.22);
    color: #a78bfa;
    font-size: 11px;
    font-weight: 700;
    margin-bottom: 14px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    svg { font-size: 11px; }
  }

  h1 {
    font-size: 28px;
    font-weight: 900;
    color: #f1f5f9;
    margin: 0 0 10px;
    line-height: 1.2;

    span { color: #a78bfa; }
  }

  p {
    font-size: 13.5px;
    color: #6b7280;
    max-width: 480px;
    line-height: 1.7;
    margin: 0 0 24px;
  }

  .hero-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;

    .btn-primary {
      display: inline-flex;
      align-items: center;
      gap: 7px;
      padding: 10px 22px;
      background: #9333EA;
      border: none;
      border-radius: 9px;
      color: #fff;
      font-size: 13px;
      font-weight: 700;
      cursor: pointer;
      font-family: inherit;
      transition: background 0.18s, transform 0.14s;
      text-decoration: none;
      &:hover { background: #7e22ce; transform: translateY(-1px); }
      svg { font-size: 14px; }
    }

    .btn-ghost {
      display: inline-flex;
      align-items: center;
      gap: 7px;
      padding: 10px 20px;
      background: transparent;
      border: 1px solid rgba(255,255,255,0.1);
      border-radius: 9px;
      color: #9ca3af;
      font-size: 13px;
      cursor: pointer;
      font-family: inherit;
      transition: all 0.15s;
      &:hover { border-color: rgba(147,51,234,0.4); color: #a78bfa; }
      svg { font-size: 14px; }
    }
  }
`;

/* ── STATS ROW ── */
export const StatsRow = styled.div`
  display: flex;
  gap: 0;
  background: #111;
  border-bottom: 1px solid rgba(255,255,255,0.06);

  .stat-item {
    flex: 1;
    padding: 14px 20px;
    border-inline-end: 1px solid rgba(255,255,255,0.05);
    display: flex;
    align-items: center;
    gap: 12px;

    &:last-child { border-inline-end: none; }

    .stat-icon {
      width: 36px; height: 36px;
      border-radius: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      svg { font-size: 16px; }
    }

    .stat-text {
      .num { font-size: 18px; font-weight: 800; color: #f1f5f9; line-height: 1.1; }
      .lbl { font-size: 11px; color: #4b5563; margin-top: 1px; }
    }
  }
`;

/* ── SERVICES GRID ── */
export const SectionTitle = styled.div`
  padding: 28px 32px 16px;

  .s-label {
    font-size: 11px;
    color: #4b5563;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    margin-bottom: 4px;
  }

  h2 {
    font-size: 17px;
    font-weight: 800;
    color: #f1f5f9;
    margin: 0;
    span { color: #a78bfa; }
  }
`;

export const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  padding: 0 32px;

  @media (max-width: 900px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 580px) { grid-template-columns: 1fr; }
`;

export const ServiceCard = styled.div`
  background: #161616;
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 12px;
  padding: 22px 20px 18px;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0; right: 0;
    width: 80px; height: 80px;
    background: radial-gradient(circle, ${p => p.glow || 'rgba(147,51,234,0.1)'} 0%, transparent 70%);
    border-radius: 50%;
    transform: translate(20px, -20px);
    pointer-events: none;
  }

  &:hover {
    border-color: ${p => p.accent || 'rgba(147,51,234,0.35)'};
    transform: translateY(-3px);
    box-shadow: 0 8px 28px rgba(0,0,0,0.35);
  }

  .card-icon {
    width: 46px; height: 46px;
    border-radius: 12px;
    background: ${p => p.iconBg || 'rgba(147,51,234,0.12)'};
    border: 1px solid ${p => p.iconBorder || 'rgba(147,51,234,0.2)'};
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
    svg { font-size: 20px; color: ${p => p.iconColor || '#a78bfa'}; }
  }

  .card-title {
    font-size: 15px;
    font-weight: 800;
    color: #f1f5f9;
    margin-bottom: 6px;
  }

  .card-desc {
    font-size: 12px;
    color: #6b7280;
    line-height: 1.65;
    margin-bottom: 16px;
  }

  .card-tags {
    display: flex;
    gap: 5px;
    flex-wrap: wrap;
    margin-bottom: 16px;

    .tag {
      padding: 2px 9px;
      border-radius: 20px;
      font-size: 10px;
      font-weight: 600;
      background: rgba(255,255,255,0.05);
      color: #6b7280;
      border: 1px solid rgba(255,255,255,0.07);
    }
  }

  .card-cta {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 700;
    color: ${p => p.iconColor || '#a78bfa'};
    svg { font-size: 12px; transition: transform 0.15s; }
    &:hover svg { transform: translateX(-3px); }
  }
`;
